import { rootActions } from "../reducers/root.slice";
import { put, select } from "typed-redux-saga";
import { setStatus } from "../dom-utils";
import ColumnUtils from "../utils/ColumnUtils";
import { TColumnName } from "../types";
import { selectRootState } from "../selectors";

function* loadPrevOrNextColumnSaga(
  action: ReturnType<typeof rootActions.loadPrevOrNextColumnSaga>
) {
  const {
    leftPanel,
    continuousColumns,
    categoricalColumns,
    categoricalPredictionColumns,
    continuousPredictionColumns,
  } = yield* select(selectRootState);

  const allColumns: TColumnName[] = ColumnUtils.combine({
    categoricalColumns,
    continuousColumns,
    categoricalPredictionColumns,
    continuousPredictionColumns,
    selectedMethod: leftPanel.selectedMethod,
  });

  const currentColumnIndex = allColumns.findIndex(
    (column) => column === leftPanel.selectedColumn
  );

  let nextColumn: TColumnName | undefined;

  if (action.payload === "prev") {
    const previousColumnIndex = Math.max(currentColumnIndex - 1, 0);
    nextColumn = allColumns[previousColumnIndex];
  }
  if (action.payload === "next") {
    const nextColumnIndex = Math.min(
      currentColumnIndex + 1,
      allColumns.length - 1
    );
    nextColumn = allColumns[nextColumnIndex];
  }

  if (!nextColumn) {
    setStatus("Invalid column: " + String(nextColumn));
  } else {
    yield* put(rootActions.setSelectedColumn(nextColumn));
  }
}

export default loadPrevOrNextColumnSaga;
